const MuiList = {
    root: {
        paddingTop: '0px',
        paddingBottom: '0px',
        '&.table-list': {
            '& .MuiListItem-root': {
                paddingTop: 4,
                paddingBottom: 4,
            },
            '& .MuiListItemText-root': {
                margin: 0,
            },
        },
        '&.nav-list': {
            '& .MuiListItem-root': {
                paddingTop: 7,
                paddingBottom: 7,
            },
            '& .MuiListItemText-root': {
                margin: 0,
            },
        },
    },
    padding: {
        paddingTop: '0px',
        paddingBottom: '0px',
    },
};
export default MuiList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTXVpTGlzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb25maWcvY29tcG9uZW50U3R5bGVzL011aUxpc3QvTXVpTGlzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLE9BQU8sR0FBRztJQUNkLElBQUksRUFBRTtRQUNKLFVBQVUsRUFBRSxLQUFLO1FBQ2pCLGFBQWEsRUFBRSxLQUFLO1FBQ3BCLGNBQWMsRUFBRTtZQUNkLHFCQUFxQixFQUFFO2dCQUNyQixVQUFVLEVBQUUsQ0FBQztnQkFDYixhQUFhLEVBQUUsQ0FBQzthQUNqQjtZQUNELHlCQUF5QixFQUFFO2dCQUN6QixNQUFNLEVBQUUsQ0FBQzthQUNWO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixxQkFBcUIsRUFBRTtnQkFDckIsVUFBVSxFQUFFLENBQUM7Z0JBQ2IsYUFBYSxFQUFFLENBQUM7YUFDakI7WUFDRCx5QkFBeUIsRUFBRTtnQkFDekIsTUFBTSxFQUFFLENBQUM7YUFDVjtTQUNGO0tBQ0Y7SUFDRCxPQUFPLEVBQUU7UUFDUCxVQUFVLEVBQUUsS0FBSztRQUNqQixhQUFhLEVBQUUsS0FBSztLQUNyQjtDQUNGLENBQUM7QUFFRixlQUFlLE9BQU8sQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IE11aUxpc3QgPSB7XG4gIHJvb3Q6IHtcbiAgICBwYWRkaW5nVG9wOiAnMHB4JyxcbiAgICBwYWRkaW5nQm90dG9tOiAnMHB4JyxcbiAgICAnJi50YWJsZS1saXN0Jzoge1xuICAgICAgJyYgLk11aUxpc3RJdGVtLXJvb3QnOiB7XG4gICAgICAgIHBhZGRpbmdUb3A6IDQsXG4gICAgICAgIHBhZGRpbmdCb3R0b206IDQsXG4gICAgICB9LFxuICAgICAgJyYgLk11aUxpc3RJdGVtVGV4dC1yb290Jzoge1xuICAgICAgICBtYXJnaW46IDAsXG4gICAgICB9LFxuICAgIH0sXG4gICAgJyYubmF2LWxpc3QnOiB7XG4gICAgICAnJiAuTXVpTGlzdEl0ZW0tcm9vdCc6IHtcbiAgICAgICAgcGFkZGluZ1RvcDogNyxcbiAgICAgICAgcGFkZGluZ0JvdHRvbTogNyxcbiAgICAgIH0sXG4gICAgICAnJiAuTXVpTGlzdEl0ZW1UZXh0LXJvb3QnOiB7XG4gICAgICAgIG1hcmdpbjogMCxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbiAgcGFkZGluZzoge1xuICAgIHBhZGRpbmdUb3A6ICcwcHgnLFxuICAgIHBhZGRpbmdCb3R0b206ICcwcHgnLFxuICB9LFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTXVpTGlzdDtcbiJdfQ==